import {capitalizeFirst} from '@wandb/weave/core/util/string';

import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {mappedBooleanDisplayValue} from '../utils';
import {
  createBooleanDisplayFn,
  createEnumDisplayFn,
} from './linePlotDisplayFactories';

export const getGroupSettingDisplayRow = createBooleanDisplayFn({
  field: 'useRunsTableGroupingInPanels',
  label: 'Use grouping in charts',
  groupTitle: 'Grouping',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.useRunsTableGroupingInPanels,
  formatter: (value: boolean) => mappedBooleanDisplayValue(value),
});

export const getGroupAggDisplayRow = createEnumDisplayFn({
  field: 'groupAgg',
  label: 'Group aggregation',
  groupTitle: 'Grouping',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.groupAgg,
  formatter: value => capitalizeFirst(value),
});
